var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"month-year-picker"},[_c('input-dropdown',{staticClass:"cashflow-category-dropdown",attrs:{"options":_vm.options,"first-selected":_vm.date,"on-select":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }